/**
 * 登录模块接口列表
 */
import { get, post } from '../http'; // 导入http中创建的axios实例
export const login = {
    login(params) {
        return post(`${process.env.VUE_APP_BASE_API}/appLogin`, params);
    },
    getInfo(params) {
        return get(`${process.env.VUE_APP_BASE_API}/getInfo`, params);
    },
    logout() {
        return post(`${process.env.VUE_APP_BASE_API}/logout`);
    },
    resetPwd(params) {
        return post(`${process.env.VUE_APP_BASE_API}/system/user/resetPwd`, params);
    }
}